import Model from './Model'
import { ReportStateType } from '@/enums/ReportStateType'

export default class ReportRow extends Model {
  createdAt: string
  id: number
  proovCode: string
  state: string
  ownerId: number
  dropoff: boolean
  fullDropoff: boolean
  autoRestart: boolean
  dropoffFinishedAt: string
  imagePath: string = null
  informations = null
  title: string = null
  identifier: string = null
  description: string = null
  updatedAt: string
  finishedAt: string
  template = {
    icon: {
      name: null,
      width: null,
      height: null
    },
    type: null
  }

  parseRow(report, locale) {
    this.setImagePath(report._preview_picture)
    this.setTitle(this.translateField(report._title, locale))
    this.setInformations(report, locale)
    this.setIdentifier(report)
    this.setDescription(report, locale)
    this.setTemplate(report)
    this.setIdentifier(report)
  }

  setImagePath(picture) {
    this.imagePath = picture ? picture._picture.path : null
  }

  setTitle(title) {
    this.title = title
  }

  setIdentifier(report) {
    this.identifier = report.identifer_items ? report.identifer_items.value : null
  }

  setInformations(report, locale) {
    if (!report.meta) {
      return
    }
    const meta = report.meta
      .filter((x) => x.value.trim().length > 0)
      .map((x)    => `${this.translateField(x._title, locale)}: ${x.value}`)
    this.informations = [meta[0], meta[1]].filter((x) => x != null)
  }

  setDescription(report, locale) {
    this.description = this.translateField(report._description, locale)
  }

  setTemplate(report) {
    this.setTemplateIcon(report)
    this.setTemplateType(report)
  }

  setTemplateIcon(report) {
    this.template.icon.name = !report.dropoff ? 'report-simple' :
                              report.fullDropoff ? 'report-double' : 'report-double-dash'
    this.template.icon.width = !report.dropoff ? '10' : report.fullDropoff ? '14' : '14'
    this.template.icon.height = !report.dropoff ? '14' : report.fullDropoff ? '18' : '17'
  }

  setTemplateType(report) {
    this.template.type = !(report && report.dropoff) ? 'simple' : report.fullDropoff ? 'full_dropoff' : 'dropoff'
  }
}
